// @ts-nocheck
import { Button } from "../../ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card";
import { RefreshCw, Shield, AlertTriangle } from "lucide-react";
import { useProfile } from "../../../contexts/ProfileContext";
import { useNavigate } from "react-router-dom";
import { getRoleDisplayName } from "../../../utils/role";
import { UserStats, UserManagement, DataSchedulerControl, SchedulerLogs, ManualTriggerControl, SchedulerConfigControl, CustomDataTrigger, AzureTierManager, PushTokenStatus, PushTokenControl, TradingDataControl, TradingCollectorControl, StockbitMigrationControl, StockMigrationControl, ManageVideoTutorials, AnnouncementControl, StockSplitManager, RustProcessorControl, PythonScraperControl, BootcampEnrollments } from "../shared";
import { ReferralManagement } from "../shared/ReferralManagement";

export function DeveloperDashboard() {
  const navigate = useNavigate();
  const { profile } = useProfile();
  
  // Guard check
  if (!profile || profile.role !== 'developer') {
    return (
      <Card className="w-full max-w-md mx-auto">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="w-5 h-5" />
            Access Denied
          </CardTitle>
          <CardDescription>
            You don't have permission to access this page.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Shield className="w-4 h-4" />
              <span>Current role: {getRoleDisplayName(profile?.role || '')}</span>
            </div>
            <Button onClick={() => navigate('/')} className="w-full">
              Go to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    );
  }

  const handleRefresh = () => {
    // Refresh will be handled by each component internally
    window.location.reload();
  };

  return (
    <div className="p-4 md:p-6 lg:p-8 w-full space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h1 className="text-2xl sm:text-3xl font-semibold">Developer Dashboard</h1>
          <p className="text-sm sm:text-base text-muted-foreground">User management and platform overview</p>
        </div>
        <Button onClick={handleRefresh} variant="outline" size="sm" className="w-full sm:w-auto">
          <RefreshCw className="h-4 w-4 mr-2" />
          Refresh Data
        </Button>
      </div>

      {/* User Statistics */}
      <UserStats apiPrefix="developer" />

      {/* Bootcamp Enrollments */}
      <BootcampEnrollments apiPrefix="developer" />

      {/* Video Tutorial Management */}
      <ManageVideoTutorials />

      {/* Referral Management */}
      <ReferralManagement apiPrefix="developer" />

      {/* User Management */}
      <UserManagement apiPrefix="developer" />

      {/* Announcement Popup Manager */}
      <AnnouncementControl />

      {/* Stock Split Manager */}
      <StockSplitManager apiPrefix="developer" />

      {/* Trading Data Emergency Control */}
      <TradingDataControl />


      {/* Scheduler Configuration */}
      <SchedulerConfigControl />

      {/* Rust Processor Control */}
      <RustProcessorControl />

      {/* Python Scrapers (Kepemilikan) */}
      <PythonScraperControl />

      {/* Manual Data Trigger Progress */}
      <ManualTriggerControl />

      {/* Custom Data Trigger */}
      <CustomDataTrigger />

      {/* Azure Tier Manager */}
      <AzureTierManager />

      {/* Trading Data Collector Control */}
      <TradingCollectorControl />

      {/* Stockbit Migration Control */}
      <StockbitMigrationControl />
      <StockMigrationControl />

      {/* Stockbit Push Token Manager */}
      <PushTokenControl />

      {/* Stockbit Push Token History */}
      <PushTokenStatus />

      {/* Scheduler Data Progress */}
      <DataSchedulerControl />

      {/* Scheduler Logs */}
      <SchedulerLogs />
    </div>
  );
}
